import jQuery from "jquery";
window.$ = window.jQuery = jQuery;

import validate from 'jquery-validation';


var validationOptions = {
	errorClass: "help-block block-error",
	errorElement: "span",
	ignore: [], //Ignore nothing - -Not even hidden fields
	//ignore: "#jobProductTemplate *",
	/*debug: true,
	invalidHandler: function (e, validator) {
		//For testing only!

		//validator.errorList contains an array of objects, where each object has properties "element" and "message".  element is the actual HTML Input.
		for (var i = 0; i < validator.errorList.length; i++) {
			console.log(validator.errorList[i]);
		}

		//validator.errorMap is an object mapping input names -> error messages
		for (var i in validator.errorMap) {
			console.log(i, ":", validator.errorMap[i]);
		}
	},*/

	highlight: function (element, errorClass, validClass) { 
		var matchingNumberBox = $(element).attr("type") == "number";
		var matchingInputGroup = $(element).parent().hasClass("input-group");

		if (matchingNumberBox == true) { //Is a number box 
			if (matchingInputGroup == true) { //We're in an input group
				$(element).parents('.input-group').removeClass('has-success');
				$(element).parents('.input-group').addClass('has-error has-feedback');
			} else { //Likely in a table cell
				$(element).parents('td').removeClass('has-success');
				$(element).parents('td').addClass('has-error');
			}
		} else {
			$(element).parents('.form-group').removeClass('has-success');
			$(element).parents('.form-group').addClass('has-error has-feedback');
		}


	},
	unhighlight: function (element, errorClass, validClass) {
		var matchingNumberBox = $(element).attr("type") == "number";
		var matchingInputGroup = $(element).parent().hasClass("input-group");

		if (matchingNumberBox == true) { //Is a number box 
			if (matchingInputGroup == true) { //We're in an input group
				$(element).parents('.input-group').removeClass('has-error');
				$(element).parents('.input-group').addClass('has-success');
			} else { //Likely in a table cell
				$(element).parents('td').removeClass('has-error');
				$(element).parents('td').addClass('has-success');
			}
		} else {
			$(element).parents('.form-group').removeClass('has-error');
			$(element).parents('.form-group').addClass('has-success');
		}


	},
	errorPlacement: function (error, element) {
		var matchingInputGroup = element.parent().hasClass("input-group");
		var matchingDropdown = element.next().hasClass("bootstrap-select");
		var matchingCheckbox = element.attr("type") == "checkbox";
		var matchingNumberBox = element.attr("type") == "number";
		var matchingCKEditor = $(element).hasClass("ckeditor");
		var matchingSelect2 = $(element).hasClass("select2");

		if (matchingNumberBox == true) { //Is a number box 
			//Do nothing -- do not place an error message

		} else if (matchingCKEditor == true) { //CKEditor box
			error.insertAfter(element.next());

		} else if (matchingInputGroup == true) { //uses bootstrap input grouping
			error.insertAfter(element.parent());

		} else if (matchingDropdown == true) { //Fancy dropdown box
			error.insertAfter(element.next());

		} else if (matchingCheckbox) { //Checkboxes
			error.insertAfter(element.parent("label").parent("div"));

		} else if (matchingSelect2) { //Select2 select box
			error.insertAfter(element.next('span'));

		} else { //Standard text box
			error.insertAfter(element);
		};
	}
}

document.addEventListener( 'DOMContentLoaded', function () {

    //Setup validation on each form that requires it
	$(".validate").each(function () {
		$(this).validate(validationOptions);
    });

});